import React from "react";
import styles from "./style.module.css";

const TabNotification = props => {
  const { options, active, init, setActive, className = "", ...other } = props;

  let activeVar;
  if (active) {
    activeVar = active;
  } else if (init) {
    setActive(init);
  } else {
    setActive(options[0].id);
  }

  return (
    <div className={`mb-0 ${styles.tab} ${className}`} {...other}>
      {options
        .filter(__option => __option.show)
        .map((__option, __option_i) => (
          <div className={__option.id === activeVar ? "active" : ""} key={__option_i}>
            <button type="button" onClick={() => setActive(__option.id)}>
              <span className={styles.label}>{__option.label}</span>{" "}
              {__option.value && <span className={styles.values}>{__option.value}</span>}
            </button>
          </div>
        ))}
    </div>
  );
};

const Body = props => {
  return <div className={styles.tab_body}>{props.children}</div>;
};

TabNotification.Body = Body;
export default TabNotification;
